import { render, staticRenderFns } from "./PersonalArmamentoComponent.vue?vue&type=template&id=6a09f4cc&scoped=true"
import script from "./PersonalArmamentoComponent.vue?vue&type=script&lang=js"
export * from "./PersonalArmamentoComponent.vue?vue&type=script&lang=js"
import style0 from "./PersonalArmamentoComponent.vue?vue&type=style&index=0&id=6a09f4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09f4cc",
  null
  
)

export default component.exports